/* ------------------------------------------------------------
 * Created By	: CodeBhagat v2.0
 * Created Date	: 12/27/2016
 * Component	: SalesbyCategoryModule
 * Purpose		: Module for SalesbyCategory.
 * Copyright	: Copyright 2014-2016 CodeBhagat LLC. All Rights Reserved.
 * Restrictions	: The generated code is for evaluation purpose only. Use of this generated code requires valid softare license.
 * ------------------------------------------------------------
*/

import { NgModule }       from '@angular/core';
import { CommonModule }   from '@angular/common';
import { FormsModule }    from '@angular/forms';
import { SharedModule } from '../shared/Shared.module';

import { SalesbyCategoryService } from './SalesbyCategory.service';
import { SalesbyCategoryListComponent } from './SalesbyCategoryList.component';
import { SalesbyCategorySearchComponent } from './SalesbyCategorySearch.component';
import { SalesbyCategoryDetailsComponent } from './SalesbyCategoryDetails.component';

import { SalesbyCategoryRoutingModule } from './SalesbyCategory-routing.module';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
	SharedModule,
    SalesbyCategoryRoutingModule
  ],
  declarations: [
    SalesbyCategoryListComponent,
	SalesbyCategorySearchComponent,
	SalesbyCategoryDetailsComponent
  ],
  providers: [
    SalesbyCategoryService
  ]
})

export class SalesbyCategoryModule { }



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/SalesbyCategory/SalesbyCategory.module.ts